export const environment = {
  production: true,
  development: false,
  test: false,
  api: 'https://loteriafoxy.pl/api',
  recaptchaV3SiteKey: '6Lf6mbcpAAAAAO6YyIz5-OHwHYjKDIVvyi2HCvrH',
  gtm: 'DC-13117613',
  serverPort: 4004,
  domain: 'loteriafoxy.pl',
  endLotteryDate: new Date(2025, 10, 16, 0, 1, 0),
};
